export const GA_ID = 'G-1V97D8DLWN';

declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
  }
}

export const pageView = (path: string): void => {
  if (!window.gtag) return;

  window.gtag('config', GA_ID, {
    page_path: path,
  });
};

export const trackEvent = (
  name: string,
  params: Record<string, any> = {}
): void => {
  if (!window.gtag) return;

  window.gtag('event', name, params);
};